// export const API_URL = 'https://uat2.weplus.id/api-broker-management/dashboard'
// export const API_URL = 'http://127.0.0.1:8000/dashboard'
export const API_URL = 'https://cms.weplus.id/api-broker-management/dashboard'
export const WEPLUS_LOGO = 'https://content.weplus.id/production/logo/weplus.png'
// export const HOMEPAGE = 'dashboard-fins/'
export const HOMEPAGE = ''
export const TEMPLATE_URL = 'https://content.weplus.id/production/broker-management/registration_template.xlsx'